
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { PqtMeasurement } from '../../backend/backendapi';
import { formatDateTimeForInput, parseDateTimeFromInput } from '../../../util';

@Component
export default class PqtMeasurementRowSeparateTesterEditor extends Vue {
  @Prop({ required: true })
  readonly measurement!: PqtMeasurement;

  get testDate(): string | null {
    if (!this.measurement.testDate) {
      return null;
    } else {
      return formatDateTimeForInput(this.measurement.testDate);
    }
  }

  set testDate(testDate: string | null) {
    if (!this.measurement.testDate) {
      this.$set(this.measurement, 'testDate', null);
    }
    this.measurement.testDate = !testDate ? undefined : parseDateTimeFromInput(testDate);
  }
}
